import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ProductImageModule} from '../product-image/product-image.module';
import {ButtonModule} from '../button/button.module';
import {SuggestCardComponent} from './suggest-card.component';
import {ProductQuantityControlsModule} from '../product-quantity-controls/product-quantity-controls.module';
import {PrimePetalLongModule} from '../prime-petal-long/prime-petal-long.module';
import {MultiCountryCurrencyModule} from '../../pipes/multi-country-currency/multi-country-currency.module';
import {OfferPetalModule} from '../offer-petal/offer-petal.module';

@NgModule({
  declarations: [SuggestCardComponent],
  exports: [SuggestCardComponent],
  imports: [
    CommonModule,
    RouterModule,
    ProductImageModule,
    ButtonModule,
    ProductQuantityControlsModule,
    PrimePetalLongModule,
    MultiCountryCurrencyModule,
    OfferPetalModule,
  ],
})
export class SuggestCardModule {}
